import { render, staticRenderFns } from "./MailTemplate.vue?vue&type=template&id=7c6eda84"
import script from "./MailTemplate.vue?vue&type=script&lang=js"
export * from "./MailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports